import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type OptionsLayout = 'horizontal' | 'vertical';
export type OptionsContext = 'commandes' | 'conseils';

@Component({
  standalone: true,
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
  imports: [CommonModule],
})
export class OptionsComponent {
  @Input() layout: OptionsLayout = 'horizontal';
  @Input() context: OptionsContext = 'commandes';
  @Input() slice: 'complete' | 'incomplete' = 'incomplete';

  @Output() exportClick = new EventEmitter<'complete' | 'incomplete'>();
  @Output() viewClick = new EventEmitter<'complete' | 'incomplete'>();

  get exportLabel(): string {
    return this.context === 'commandes' ? 'Export des commandes incompletes' : 'Export des conseils en retard';
  }

  get viewLabel(): string {
    return this.context === 'commandes' ? 'Voir mes commandes incompletes' : 'Voir mes conseils livres';
  }

  onExport(): void {
    this.exportClick.emit(this.slice);
  }
  onView(): void {
    this.viewClick.emit(this.slice);
  }
}
